import {OperatorPropertyDto} from '../../common/shared/api/nicolas/vo/OperatorPropertyDto.interface';
import {OperatorProperty} from '../generated/types';
import {createCash} from './Cash';
import {createSingleTicketInfo} from './SingleTicketInfo';

export function createOperatorProperty({
  copy,
  thumbnail,
  is_view_count,
  is_event,
  is_text_viewer,
  title,
  self_censorship,
  cash_info,
  ticket_info,
  is_book,
  rec_id,
}: OperatorPropertyDto): OperatorProperty {
  return {
    copy,
    thumbnail,
    title,
    isEvent: is_event,
    isViewCount: is_view_count,
    isTextViewer: is_text_viewer,
    selfCensorship: self_censorship,
    cashInfo: cash_info ? createCash(cash_info) : undefined,
    ticketInfo: ticket_info
      ? ticket_info.map(ticket => createSingleTicketInfo(ticket))
      : undefined,
    isBook: is_book,
    rec_id,
  };
}
